"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPersonNameConfig = void 0;
/**
 * The default person name configuration.
 * Examples: John H. Smith, John Smith, John H., John, Smith, Hank
 */
exports.defaultPersonNameConfig = {
    formats: [
        '${givenName} ${middleInitial}. ${familyName}',
        '${givenName} ${familyName}',
        '${givenName} ${middleInitial}.',
        '${givenName}',
        '${familyName}',
        '${middleName}'
    ]
};
//# sourceMappingURL=person-name.js.map